import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import TipCalculatorContent from '../../components/Pages/TipCalculator';

const { displayName } = config;

export default function TipCalculator(): React.ReactElement {
  document.title = `${displayName}: Tip Calculator`;

  return (
    <Layout>
      <TipCalculatorContent />
    </Layout>
  );
}
